import { Input } from '../Input';
import { AiOutlineSearch } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

export const InputSearch = ({ className, searchIcon = true, ...props }) => {
    const cn = classnames('rounded-md border-none shadow-sm sm:text-sm bg-gray-50 focus:ring-0 focus:border-none text-sm placeholder-gray-400', { ['pl-10']: searchIcon }, className);
    const { t } = useTranslation();

    return (
        <div className="relative">
            {searchIcon && (
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <AiOutlineSearch className="w-5 h-5 text-gray-400 dark:text-gray-400" stroke="currentColor" />
                </div>
            )}
            <input type="search" id="default-search" className={cn} placeholder={t('Search Here...')} {...props} />
        </div>
    );
};
